/**
 * @todo This should be exported from @ftdr/blueprint_core
 * and auto generated based on class names used in component_css
 */
export const CSS_CLASSES = {
  PROGRESS_INDICATOR_ROOT: "progress-indicator",
  PROGRESS_INDICATOR_FULL_WIDTH: "progress-indicator-full-width",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_TOP: "progress-indicator-label-placement-top",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_RIGHT: "progress-indicator-label-placement-right",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_BOTTOM: "progress-indicator-label-placement-bottom",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_LEFT: "progress-indicator-label-placement-left",
  PROGRESS_INDICATOR_LINEAR_LABEL_PLACEMENT_TOP_OR_BOTTOM: "progress-indicator-linear-label-placement-top-or-bottom",

  /** LABEL */
  PROGRESS_INDICATOR_LABEL: "progress-indicator-label",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_TOP_LABEL: "progress-indicator-label-placement-top-label",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_RIGHT_LABEL: "progress-indicator-label-placement-right-label",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_BOTTOM_LABEL: "progress-indicator-label-placement-bottom-label",
  PROGRESS_INDICATOR_LABEL_PLACEMENT_LEFT_LABEL: "progress-indicator-label-placement-left-label",
  PROGRESS_INDICATOR_SMALL_LABEL: "progress-indicator-small-label",
  PROGRESS_INDICATOR_MEDIUM_LABEL: "progress-indicator-medium-label",
  PROGRESS_INDICATOR_LARGE_LABEL: "progress-indicator-large-label",
  PROGRESS_INDICATOR_WHITE_LABEL: "progress-indicator-white-label",

  /** VALUE LABEL **/
  PROGRESS_INDICATOR_VALUE_LABEL: "progress-indicator-value-label",
  PROGRESS_INDICATOR_MEDIUM_VALUE_LABEL: "progress-indicator-medium-value-label",
  PROGRESS_INDICATOR_LARGE_VALUE_LABEL: "progress-indicator-large-value-label",

  /** CIRCULAR */
  PROGRESS_INDICATOR_CIRCULAR: "progress-indicator-circular",
  PROGRESS_INDICATOR_CIRCULAR_TRACK: "progress-indicator-circular-track",
  PROGRESS_INDICATOR_CIRCULAR_BAR: "progress-indicator-circular-bar",
  PROGRESS_INDICATOR_CIRCULAR_INDETERMINATE: "progress-indicator-circular-indeterminate",
  PROGRESS_INDICATOR_CIRCULAR_INDETERMINATE_SMALL_BAR: "progress-indicator-circular-indeterminate-small-bar",
  PROGRESS_INDICATOR_CIRCULAR_INDETERMINATE_MEDIUM_BAR: "progress-indicator-circular-indeterminate-medium-bar",
  PROGRESS_INDICATOR_CIRCULAR_INDETERMINATE_LARGE_BAR: "progress-indicator-circular-indeterminate-large-bar",
  PROGRESS_INDICATOR_CIRCULAR_VALUE_LABEL: "progress-indicator-circular-value-label",
  PROGRESS_INDICATOR_CIRCULAR_WHITE_VALUE_LABEL: "progress-indicator-circular-white-value-label",

  /** LINEAR */
  PROGRESS_INDICATOR_LINEAR: "progress-indicator-linear",
  PROGRESS_INDICATOR_LINEAR_TRACK: "progress-indicator-linear-track",
  PROGRESS_INDICATOR_LINEAR_BAR: "progress-indicator-linear-bar",
  PROGRESS_INDICATOR_LINEAR_INDETERMINATE_BAR: "progress-indicator-linear-indeterminate-bar",
  PROGRESS_INDICATOR_LINEAR_INDETERMINATE_BAR_INNER: "progress-indicator-linear-indeterminate-bar-inner",
  PROGRESS_INDICATOR_LINEAR_SMALL_BAR: "progress-indicator-linear-small-bar",
  PROGRESS_INDICATOR_LINEAR_MEDIUM_BAR: "progress-indicator-linear-medium-bar",
  PROGRESS_INDICATOR_LINEAR_LARGE_BAR: "progress-indicator-linear-large-bar",
  PROGRESS_INDICATOR_LINEAR_SMALL_TRACK: "progress-indicator-linear-small-track",
  PROGRESS_INDICATOR_LINEAR_MEDIUM_TRACK: "progress-indicator-linear-medium-track",
  PROGRESS_INDICATOR_LINEAR_LARGE_TRACK: "progress-indicator-linear-large-track",
  PROGRESS_INDICATOR_LINEAR_VALUE_LABEL: "progress-indicator-linear-value-label",
  PROGRESS_INDICATOR_LINEAR_MEDIUM_VALUE_LABEL: "progress-indicator-linear-medium-value-label",
  PROGRESS_INDICATOR_LINEAR_LARGE_VALUE_LABEL: "progress-indicator-linear-large-value-label",
  PROGRESS_INDICATOR_LINEAR_WHITE_VALUE_LABEL: "progress-indicator-linear-white-value-label",

  /** COLORS */
  PROGRESS_INDICATOR_PRIMARY_TRACK: "progress-indicator-primary-track",
  PROGRESS_INDICATOR_PRIMARY_BAR: "progress-indicator-primary-bar",
  PROGRESS_INDICATOR_SECONDARY_TRACK: "progress-indicator-secondary-track",
  PROGRESS_INDICATOR_SECONDARY_BAR: "progress-indicator-secondary-bar",
  PROGRESS_INDICATOR_INTERACTIVE_TRACK: "progress-indicator-interactive-track",
  PROGRESS_INDICATOR_INTERACTIVE_BAR: "progress-indicator-interactive-bar",
  PROGRESS_INDICATOR_ACCENT_TRACK: "progress-indicator-accent-track",
  PROGRESS_INDICATOR_ACCENT_BAR: "progress-indicator-accent-bar",
  PROGRESS_INDICATOR_GRAY_TRACK: "progress-indicator-gray-track",
  PROGRESS_INDICATOR_GRAY_BAR: "progress-indicator-gray-bar",
  PROGRESS_INDICATOR_ERROR_TRACK: "progress-indicator-error-track",
  PROGRESS_INDICATOR_ERROR_BAR: "progress-indicator-error-bar",
  PROGRESS_INDICATOR_WARNING_TRACK: "progress-indicator-warning-track",
  PROGRESS_INDICATOR_WARNING_BAR: "progress-indicator-warning-bar",
  PROGRESS_INDICATOR_SUCCESS_TRACK: "progress-indicator-success-track",
  PROGRESS_INDICATOR_SUCCESS_BAR: "progress-indicator-success-bar",
  PROGRESS_INDICATOR_WHITE_TRACK: "progress-indicator-white-track",
  PROGRESS_INDICATOR_WHITE_BAR: "progress-indicator-white-bar",

  /** PROGRESS INDICATOR OVERLAY */
  PROGRESS_INDICATOR_OVERLAY: "progress-indicator-overlay",
};
